module.exports = "/images/veil-14.jpg";